@if (terminal$ | async) {
  <mat-card appearance="outlined" class="card">
    <mat-card-header class="no-text-margin">
      <h3>{{ (terminal$ | async).name }}</h3>
      @if (currentActivity) {
        <button mat-icon-button class="close-button" (click)="cancelActivity()">
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-card-header>
    <mat-card-content>
      @switch (currentView$ | async) {
        @case ('select-language') {
          <saf-terminal-page-select-language-view
            [terminal]="terminal$ | async"
            [activity]="activity$ | async"
          (viewCompleted)="onLanguageSelected()"></saf-terminal-page-select-language-view>
        }
        @case ('add-external-company') {
          <saf-terminal-page-add-external-company-view
            [terminal]="terminal$ | async"
            [activity]="activity$ | async"
          (viewCompleted)="onCompanyCreated()"></saf-terminal-page-add-external-company-view>
        }
        @case ('add-external-employee') {
          <saf-terminal-page-add-external-employee-view
            [terminal]="terminal$ | async"
            [activity]="activity$ | async"
          (viewCompleted)="onEmployeeCreated()"></saf-terminal-page-add-external-employee-view>
        }
        @case ('confirm-external-employee') {
          <saf-terminal-page-confirm-external-employee-view
            [terminal]="terminal$ | async"
            [activity]="activity$ | async"
          (viewCompleted)="onEmployeeConfirmed()"></saf-terminal-page-confirm-external-employee-view>
        }
        @case ('schooling') {
          <saf-terminal-page-schooling-view
            [terminal]="terminal$ | async"
            [activity]="activity$ | async"
            (viewOnline)="onOnlineStart($event)"
          (viewCompleted)="onSchoolingDone()"></saf-terminal-page-schooling-view>
        }
        @case ('online') {
          <saf-terminal-page-online-view
            [planId]="planId"
            [topicId]="topicId"
            [externalEmployeeId]="externalEmployeeId"
          (viewCompleted)="onOnlineDone()"></saf-terminal-page-online-view>
        }
        @case ('poll-activity') {
          <saf-terminal-page-polling-view></saf-terminal-page-polling-view>
        }
      }
    </mat-card-content>
  </mat-card>
}
